import { IProfileData, IStreamDataPoint } from '../types/api/profile';
import { DateTime } from 'luxon';

export function convertStreamDataToChartData(
  data: IProfileData[],
  key: keyof IStreamDataPoint,
  //TODO: better to return deviceName from the API where possible, instead of getting it from filterOptions
  devicesById: any,
): Highcharts.SeriesLineOptions[] {
  const seriesMap: { [deviceId: string]: [number, number | null][] } = {};

  data.forEach((item) => {
    const localTimestamp = DateTime.fromISO(item.timestamp.date).toLocal().toMillis();
    const value = item.data[key];
    if (!seriesMap[item.deviceId]) {
      seriesMap[item.deviceId] = [];
    }
    seriesMap[item.deviceId].push([localTimestamp, value]);
  });

  return Object.keys(seriesMap).map((deviceId) => ({
    type: 'line',
    name: devicesById[deviceId]?.name ? devicesById[deviceId].name : deviceId,
    data: seriesMap[deviceId],
  }));
}
